import ListCell from '@doordash/component-list-cell';
export var TitleSizes = {
  Small: 'SMALL',
  Medium: 'MEDIUM',
  Large: 'LARGE'
};
export var NavigationTypes = {
  Back: {
    icon: ListCell.IconTypes.ArrowLeft,
    accessibilityLabel: 'Back'
  },
  Menu: {
    icon: ListCell.IconTypes.Menu,
    accessibilityLabel: 'Menu'
  },
  Close: {
    icon: ListCell.IconTypes.Close,
    accessibilityLabel: 'Close'
  },
  None: 'None'
};